import { Injectable, OnDestroy, inject } from '@angular/core';
import { fromEvent, merge, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { MakeCallService } from "./makecall.service";
import { timer } from 'rxjs';

@Injectable()
export class SessionRefreshService implements OnDestroy {
  timer: Subscription;
  SESSION_TIMEOUT = 120;
  MAX_SESSION_TIMEOUT = 2147483647;

  protected makeCall: MakeCallService = inject(MakeCallService);

  constructor() {
    this.getSessionLifetime();
  }

  getSessionLifetime() {
    this.makeCall.getCall('system/sessionlifetimeinsec').subscribe({
      next: (data: any) => {
        this.SESSION_TIMEOUT = data;
        this.startTimer();
      }
    });
  }

  startTimer(): void {
    this.clearTimer();
    const sessionTimeout : number = this.SESSION_TIMEOUT * 1000;
    const timeOut: number = sessionTimeout > this.MAX_SESSION_TIMEOUT ? this.MAX_SESSION_TIMEOUT : sessionTimeout;
    this.timer = timer(timeOut).subscribe(() => {
      window.location.reload();
    });
  }

  clearTimer(): void {
    if (this.timer) {
      this.timer.unsubscribe();
    }
  }

  ngOnDestroy(): void {
    this.clearTimer();
  }
}
